import React,{useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getDocumentsToSign,
  signDocument
} from "../../store/actions/signature/index";
import Signature from "../../components/signature/index";
import { usePermissions } from "../../customHooks";
import Page from "../../components/general/page";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const SignaturePage = ({iframe, pageRef, prevPath}) => {
  const pageItems = 12;
  const page = 0;
  const navigate = useNavigate();
  const company = useSelector(state => state.company);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const main = useSelector(state => state.main);
  const signature = useSelector(state => state.signature);

  const accountantSelected = main.accountantSelected;
  const companySelected = main.companySelected;
  const permissionUser = currentPermissions.permissionUser;

  const intl = useIntl();

  const dispatch = useDispatch();

  const { isPermissionSign } = usePermissions(currentPermissions);

  useEffect(() => {
    dispatch(getDocumentsToSign(page,
      pageItems));
  }, []);

  useEffect(() => {

    if (
      permissionUser &&
      permissionUser.userPermissions &&
      permissionUser.status.ended &&
      !isPermissionSign
    )
      window.location.href = global.location.pathname;

    if (permissionUser && accountantSelected) {
      dispatch(getDocumentsToSign(page,
        pageItems));
    }
  }, [isPermissionSign, permissionUser?.userPermissions, permissionUser?.status?.ended, accountantSelected]);

  const reloadPage = () => {
    navigate("/da-firmare");
    global.location.reload();
  };

  let ragioneSociale = company.companies.find(el => {
    return el.codiceFiscale === companySelected;
  }).ragioneSociale;

  const linkBack = {
    actionClick:  () => reloadPage(),
    pushUrl: "/da-firmare",
    text: <FormattedMessage id="signature.back" />,
    winLocation: null
  };

  return (
    <Page
      pageRef={pageRef}
      className={"contentStructure transparent"}      
      linkBack={iframe ? linkBack : null}
      title={<FormattedMessage id="signature.title" />}
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
    >
      <Signature
        documentSign={signature.documentSign}
        documentsToSign={signature.documentsToSign}
        getDocumentsToSign={getDocumentsToSign}        
        isDocumentSign={signature.isDocumentSign}
        isErrorDocumentSign={signature.isErrorDocumentSign}
        isErrorGettingDocumentsToSign={
          signature.isErrorGettingDocumentsToSign
        }
        iframe={iframe}
        isGettingDocumentsToSign={signature.isGettingDocumentsToSign}
        signDocument={signDocument.bind(this)}
        prevPath={prevPath}
      />
    </Page>
  );
};

export default SignaturePage;
